import { render } from "./agreeItem_03.vue?vue&type=template&id=15109b5c&scoped=true&ts=true"
import script from "./agreeItem_03.vue?vue&type=script&lang=ts"
export * from "./agreeItem_03.vue?vue&type=script&lang=ts"

import "./agreeItem_03.vue?vue&type=style&index=0&id=15109b5c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/ws-frontend-join/ws-frontend-join/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15109b5c"]])

export default __exports__